module.exports = __webpack_public_path__ + "img/selectedcandidateonhold.6dccd27f.svg";